import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  enterpriseSavedMessagesKey,
  savedEnterpriseMessagesRoute,
  errorMessage,
  savedNotesKey,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';
import { ApplicationActionType } from '@features/applications';

type UseCreateEnterpriseSavedMessageProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useCreateEnterpriseSavedMessage = ({
  setErrorText,
}: UseCreateEnterpriseSavedMessageProps) => {
  const client = useQueryClient();

  const { mutate: createEnterpriseSavedMessage, isLoading: isCreatingEnterpriseSavedMessage } =
    useMutation({
      mutationFn: (variables: { label: string | ApplicationActionType; is_note?: boolean, content: string, saved_message_id?: number, company_id?: number | string }) =>
        axiosInstance
          .post(savedEnterpriseMessagesRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([enterpriseSavedMessagesKey]);
          client.invalidateQueries([savedNotesKey]);
        }
      },
      onError: (error: { message?: string }) => {
        setErrorText(error?.message || errorMessage);
      },
    });

  return {
    createEnterpriseSavedMessage,
    isCreatingEnterpriseSavedMessage,
  };
};
